import { homeRoutes } from './apiRoutes';
import { axiosAuthInstance } from './auth';

export const home_page_template = () => axiosAuthInstance.get(homeRoutes.home_page_template);
export const home_page_section = () => axiosAuthInstance.get(homeRoutes.home_page_section);
export const home_page_contact = () => axiosAuthInstance.get(homeRoutes.home_page_contact);
export const howItsWorkpopup = (queryParams) => axiosAuthInstance.get(homeRoutes.howItsWorkpopup, { params: queryParams });
